<template>
    <div class="english-container">
  
      <h2>Chaque produit ne peut être associé qu’à un seul appareil.</h2>
      <h2>IOS:</h2>
      <h1>Démarrage Rapide</h1>
      

  
      <ol>
        <li>Allumez la carte intelligente.</li>
        <li>Ouvrez l’application « Find My » et appuyez sur « + ».</li>
        <li>Sélectionnez « Ajouter un autre objet ».</li>
        <li>Appuyez sur « Connecter ».</li>
        <li>Suivez les instructions à l’écran pour terminer la connexion.</li>
      </ol>
  
      <div class="divider"></div>
  
      <h2>Localiser Votre Objet <span>03</span></h2>
  
      <h3>1. Trouver l’Item Locator lorsqu’il est à proximité</h3>
  
      <p>
        Ouvrez l’application Find My et sélectionnez l’onglet « Objets ».
        Appuyez sur votre Item Locator dans la liste.
        Appuyez sur « Lire un son » pour faire sonner votre Item Locator.
        Appuyez sur « Arrêter le son » une fois votre objet retrouvé.
      </p>
  
      <h3>2. Trouver la dernière position connue de l’Item Locator</h3>
  
      <p>
        Ouvrez l’application Find My et sélectionnez l’onglet « Objets ».
        Appuyez sur votre Item Locator dans la liste.
        La dernière position connue de votre Item Locator apparaîtra sur la carte.
      </p>
  
      <div class="divider"></div>
  
      <h2>Trouver un objet hors de portée <span>04</span></h2>
  
      <h3>1. Activer « M’avertir si oublié »</h3>
  
      <p>
        Ouvrez l’application Find My et sélectionnez l’onglet « Objets ».
        Appuyez sur votre Item Locator dans la liste.
        Dans « Notifications », activez l’option
        « M’avertir si oublié ».
      </p>
  
      <h3>2. Activer « M’avertir lorsqu’il est retrouvé »</h3>
  
      <p>
        Dans Notifications, activez l’option
        « M’avertir lorsqu’il est retrouvé ».
        Lorsque votre objet est détecté par un autre appareil compatible Find My,
        vous recevrez une notification avec sa position mise à jour.
      </p>
  
      <div class="divider"></div>
  
      <h2>Lorsque votre objet est perdu <span>05</span></h2>
  
      <p>
        Ouvrez l’application Find My et sélectionnez l’onglet « Objets ».
        Appuyez sur votre Item Locator dans la liste.
      </p>
  
      <p>
        Sous le Mode Perdu, appuyez sur « Activer ».
        Un écran détaillant le Mode Perdu apparaîtra.
        Appuyez sur « Continuer » puis saisissez votre numéro de téléphone ou votre adresse e-mail.
      </p>
  
      <div class="divider"></div>
  
      <h2>Réinitialisation de votre Item Locator <span>06</span></h2>
  
      <h3>1. Supprimer l’Item Locator de Find My</h3>
  
      <p>
        Ouvrez l’application Find My et sélectionnez l’onglet « Objets ».
        Appuyez sur votre Item Locator dans la liste.
        Assurez-vous que le « Mode Perdu » est désactivé.
        Faites défiler vers le bas et appuyez sur « Supprimer l’objet ».
      </p>
  
      <h3>2. Réinitialisation d’usine</h3>
  
      <p>
        Après avoir supprimé avec succès l’Item Locator de Find My,
        appuyez rapidement quatre fois sur le bouton de fonction,
        puis maintenez-le enfoncé une cinquième fois
        jusqu’à entendre une sonnerie.
      </p>
  
      <div class="divider"></div>
  
      <h2>Mais attendez... Ce n’est pas tout <span>07</span></h2>
  
      <h3>1. Chargement</h3>
  
      <p>
        Utilisez un chargeur sans fil standard pour recharger le produit.
        Le voyant rouge reste allumé pendant la charge
        et s’éteint lorsque la batterie est complètement chargée.
      </p>
  
      <h3>2. Détection de suivi non souhaité</h3>
  
      <p>
        Si votre téléphone détecte un Item Locator inconnu
        se déplaçant avec vous, vous recevrez une notification.
      </p>
  
      <div class="divider"></div>
  
      <h2>Informations Importantes</h2>
  
      <p class="small">
        Cet appareil est conforme à la partie 15 des règles FCC.
        Son fonctionnement est soumis aux deux conditions suivantes :
      </p>
  
      <ol class="small">
        <li>Cet appareil ne doit pas provoquer d’interférences nuisibles.</li>
        <li>
          Cet appareil doit accepter toute interférence reçue,
          y compris celles pouvant provoquer un fonctionnement indésirable.
        </li>
      </ol>
  
      <p class="small">
        REMARQUE :
        Le fabricant n’est pas responsable des interférences radio ou TV
        causées par des modifications non autorisées de cet équipement.
        De telles modifications peuvent annuler le droit de l’utilisateur
        à utiliser cet appareil.
      </p>
  
      <p class="small">
        Cet équipement a été évalué afin de répondre aux exigences générales
        relatives à l’exposition aux radiofréquences.
        L’appareil peut être utilisé sans restriction dans des conditions portables.
      </p>
  
      <p class="small">
        Cet équipement a été testé et déclaré conforme aux limites applicables
        aux appareils numériques de classe B, conformément à la partie 15 des règles FCC.
      </p>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'CardFrenchLanguage',
  };
  </script>
  
  <style scoped>
  
  .english-container{
    background-color:#ffffff;
    border-radius:8px;
    padding:30px;
    margin:10px auto;
    max-width:1000px;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
  }
  
  h1{
    font-size:42px;
    margin-bottom:25px;
    color:#222;
    text-align:left;
  }
  
  h2{
    font-size:28px;
    margin-top:35px;
    margin-bottom:15px;
    color:#222;
    text-align:left;
  }
  
  h3{
    font-size:20px;
    margin-top:24px;
    margin-bottom:10px;
    color:#333;
    text-align:left;
  }
  
  p{
    font-size:15px;
    line-height:1.8;
    color:#333;
    text-align:left;
    margin-bottom:14px;
  }
  
  ol{
    padding-left:24px;
    margin-bottom:20px;
  }
  
  li{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:10px;
    text-align:left;
  }
  
  .small{
    font-size:13px;
    line-height:1.7;
  }
  
  .divider{
    width:100%;
    height:1px;
    background:#e5e5e5;
    margin:40px 0;
  }
  
  span{
    color:#888;
    font-weight:700;
  }
  
  .image_1{
    width:90%;
    max-width:600px;
    height:auto;
    margin:20px auto;
    display:block;
    border-radius:8px;
  }
  
  @media (max-width:768px){
  
    .english-container{
      padding:20px;
    }
  
    h1{
      font-size:32px;
    }
  
    h2{
      font-size:24px;
    }
  
    h3{
      font-size:18px;
    }
  
    p, li{
      font-size:14px;
    }
  }
  
  </style>